export enum SupportRequestStatus {
  unprocessed = 'unprocessed',
  inProgress = 'inProgress',
  processed = 'processed',
  archived = 'archived',
}

export interface ISupportRequestUser {
  id: string;
  firstname: string;
  lastname: string;
  avatar?: unknown;
}

export interface ISupportRequest {
  id: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  user?: ISupportRequestUser;
  name: string;
  email: string;
  title: string;
  message: string;
  status: SupportRequestStatus;
}

export interface ISupportRequestListResponse {
  items: ISupportRequest[];
  total: number;
  page: number;
  limit: number;
}

export type ListSupportRequestsQueryDto = {
  page?: number;
  limit?: number;
  search?: string;
  status?: SupportRequestStatus;
};

export type UpdateSupportRequestStatusDto = {
  status: SupportRequestStatus;
};
